import { Injectable } from "@angular/core";
import { Action, Selector, State, StateContext } from "@ngxs/store";
import { QueryParamsAction } from "./query-params.action";

export interface QueryParamsModel {
}

@State<QueryParamsModel>({
  name: 'queryParamState',
  defaults: {}
})

@Injectable()

export class QueryParamsState {
  @Selector()
  static queryParams(state: QueryParamsModel | any) {
    return state;
  }

  @Action(QueryParamsAction)
  queryParamsAction({getState, patchState}: StateContext<QueryParamsModel>, {payload}: QueryParamsAction) {
    const state = getState();
    patchState(payload);
  }
}